var gift = false;
var noGift = false;

var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Gift Vouchers'.toLowerCase()) > -1) {
    gift = true;
  } /*else {
    noGift = true;
  }*/
}
document.addEventListener('crJQActivated', function (e) {
  if (gift === true /*&& noGift === false*/) {
    jqCR('#shipping-calculator').remove();
    console.log('---------- remove ------------')
  }
})
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct6 === true) {
    if (currentHour < 15) {
      picker.set('min', 2)  
    } else {
      picker.set('min', 3)  
    }
    picker.set('disable', blackoutdatesCollection);
  } else
  if (specialProduct3 === true) {
   //  console.log('Special product 5')
  	// picker.set('disable', [true, 
   //                         { from: [2020, 8, 10], to: [2024, 4, 14] }
   //                         , { from: [2024, 4, 30], to: [2025, 9, 7] }])
    picker.set('min', 2)
    picker.set('disable', blackoutdatesCollection);
  }	else 
  if (specialProduct4 === true) {
    console.log('Special product 4')
  	picker.set('disable', [true, 
                           { from: [2024, 11, 25], to: [2025, 1, 6] },
                           { from: [2025, 1, 15], to: [2035, 1, 6] },
                           
                          ]);
    //picker.set('disable', [2, 3, 4, 5, 6, 7])
    picker.set('min', 1)
    picker.set('disable', blackoutdatesCollection);
  }	else 
  if (specialProduct2 === true) {
    console.log('Special product')
  	picker.set('disable', [true, 
                           { from: [2020, 8, 10], to: [2023, 4, 13] }
                           , { from: [2023, 4, 15], to: [2025, 9, 7] }
                          ]);
    //picker.set('disable', [2, 3, 4, 5, 6, 7])
    picker.set('min', 1)
    picker.set('disable', blackoutdatesCollection);
  }	else 
  if (specialProduct === true) {
    console.log('Special product')
  	
    picker.set('min', 1)
    picker.set('disable', blackoutdatesCollection);
  }	else {
    picker.set('disable', blackoutdatesCollection);
  }  

}


var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if (specialProduct6 === true) {
    timepicker.set('interval', 30);
  	timepicker.set('min',[9, 30]);
    timepicker.set('max',[14, 30]);
  }
  if (specialProduct === true) {
    timepicker.set('interval', 30);
  	timepicker.set('min',[10, 30]);
    timepicker.set('max',[14, 0]);
  }
  if (specialProduct2 === true) {
  	timepicker.set('min',[9, 0]); 
  }

  if (specialProduct3 === true) {
  	timepicker.set('min',[6, 0]);
    timepicker.set('max',[15, 0]);
    timepicker.set('interval', 30);
  }

  if (specialProduct4 === true) {
  	timepicker.set('min',[6, 0]);
    timepicker.set('max',[15, 0]);
    timepicker.set('interval', 30);
  }
}